import SubscriptionPlan from "@/models/subscription/SubscriptionPlan";
import store from "@/state/store";
import {
  showErrorSnackbar,
  showSuccessSnackbar,
} from "@/utils/snackbarUtils";

export default class IdealConfirmationService {
  // 📦 Stripe instance
  private stripe = (window as any).Stripe(process.env.VUE_APP_STRIPE_KEY);

  /**
   * 🔨 Handles the iDEAL deep linking on result
   * @param route
   * @param router
   */
  public resolveIdealConfirmationResponse(router: any) {
    const route = router.currentRoute;
    const mode = route.query.mode;
    const priceId = route.query.priceId;
    const promotionalCode = route.query.promoCode;
    const redirectStatus = route.query.redirect_status;
    const setupIntent = route.query.setup_intent;
    const setupIntentClientSecret = route.query.setup_intent_client_secret;
    router.replace({ query: {} });

    if (redirectStatus == null || redirectStatus === undefined) {
      return;
    }

    if (redirectStatus === "succeeded") {
      this.stripe
        .retrieveSetupIntent(setupIntentClientSecret)
        .then(async (result: any) => {
          switch (mode) {
            case "change": {
              this.handlePaymentMethodChangeFlow(result);
              break;
            }
            case "create-subscription": {
              this.handleSubscriptionActivationFlow(priceId, promotionalCode);
              break;
            }
          }
        });
    } else {
      showErrorSnackbar("Something went wrong with your payment processing. Try again or contact us for further assistance");
    }
  }

  /**
   * 🔨 Makes the needed API call in order to facilitate the payment method change flow
   * @param result
   */
  private async handlePaymentMethodChangeFlow(result: any) {
    try {
      await store.dispatch("setPaymentMethod", "sepa_debit");
      await store.dispatch("getCurrentPaymentMethod");
      showSuccessSnackbar("Your payment method was successfully changed!");
    } catch (error: any) {
      showErrorSnackbar(error.response?.data.message);
    }
  }

  /**
   * 🔨 Makes the needed API call in order to facilitate the subscription creation flow
   * @param result
   */
  private async handleSubscriptionActivationFlow(priceId: string, promotionalCode: string) {
    const subscriptionPlan: SubscriptionPlan = store.getters.getSubscriptionPlanBasedOnPriceId(priceId);
    await store.dispatch("setPaymentMethod", "sepa_debit");
    await store.dispatch("createSubscription", { type: subscriptionPlan.type, promotionalCode: promotionalCode});
    await store.dispatch("getCurrentPaymentMethod");
    await store.dispatch("getCurrentSubscription");
    await store.dispatch("fetchCurrentSubscriptionPlan");
    await store.dispatch("fetchAvailableSubscriptionPlans");
    await store.dispatch("getSubscriptionInvoices");
    showSuccessSnackbar("Your subscription was sucessfully activated");
  }
}
